import type { App } from 'vue';
import type { RouteRecordRaw, Router, RouterHistory } from 'vue-router';
import { createRouter, createWebHashHistory } from 'vue-router';
import routesList from './routes';
import { getIsNeedBindMobile, getIsNeedLogin, queryParamsConvergence, redirectHref, setCorpIco } from './router-util';
import setGFun from '@/h5/set-g-fun';
import reportNew from '@/h5/report-new';
import { handleAuth } from '@/utils/auth';
import { getWxOfficialAuthQuery } from '@/utils/wx-auth-query';

const routes: Array<RouteRecordRaw> = [
  ...routesList
];

let routerInstance: any = null;

const newRouter = (app: App<Element>): { router: Router; history: RouterHistory } => {
  const history = createWebHashHistory(process.env.BASE_URL || '');
  const router = createRouter({
    history,
    routes,
    scrollBehavior() {
      return { top: 0 };
    }
  });

  router.beforeEach(async (to: any, from: any) => {
    document.title = '\u200E';
    window.Monitor && window.Monitor.switchPage(to, from);
    if (app.config.globalProperties.$leavePageFun) {
      // 离开活动落地页和签到页不执行离开页面上报逻辑
      if (!['ActivitiesLandingPage', 'ActivitiesSignIn'].includes(from.name)) {
        await app.config.globalProperties.$leavePageFun();
      }
    }

    // 参数聚合逻辑
    await queryParamsConvergence(app, { urlObj: to.query, name: to.name });

    setGFun.install(app);

    setCorpIco(app);

    // 如果是访问登录页，则不在执行下面逻辑
    if (to.name === 'Login') return true;

    // 重定向后会导致走两次授权逻辑，code被消费两次，故添加逻辑判断在重定向后不再往后继续执行
    if (redirectHref(app)) return true;

    const isNeedLogin = await getIsNeedLogin(app);
    if (isNeedLogin && to.name !== 'Tools') {
      const { $isMp, $isQw, $isWx } = app.config.globalProperties;
      const searchAuthQuery = getWxOfficialAuthQuery(window.location.search, {
        isWx: $isWx,
        isQw: $isQw,
        isMp: $isMp
      });
      // 非微信环境自动登录 或者 存在code参数(微信公众号登录重定向回来需要用code换取用户信息)
      // 微信环境在layout中通过用户主动点击授权（不然会有快照页）
      // 企微环境下 $isWx 也会为true 再判断 $isQw 为true 也走静默授权
      if (!$isWx || $isQw || to.query?.code || searchAuthQuery.code) {
        await handleAuth(app.config.globalProperties);
      }
    }

    // 当在微信小程序里面访问时，需要设置新版本的wx sdk，用于向小程序传值
    await getIsNeedBindMobile(app);

    reportNew.install(app);

    return true;
  });

  routerInstance = router;

  return { router, history };
};

export default newRouter;

export { routerInstance };
